// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"70e969a1","239":"ea1ee442"}[chunkId] + ".chunk.js";
};